export default __webpack_public_path__ + "static/media/2.9a6e9dec.jpg";